import { FC } from 'react';
import { Box, Drawer } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';

import { CloseModalButton } from 'shared/ui/CloseModalButton';
import { Icon } from 'shared/ui/Icon';
import { Paper } from 'shared/ui/Paper';
import { t } from 'i18next';

interface Props {
	isOpen: boolean;
	handleOpen: () => void;
	handleClose: () => void;
	children: React.ReactNode;
}

export const FilterDrawer: FC<Props> = ({ isOpen, handleOpen, handleClose, children }) => {
	return (
		<>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					minWidth: '45px',
					minHeight: '45px',
					borderRadius: '12px',
					backgroundColor: ColorPalette.royalBlue,
					cursor: 'pointer',
				}}
				onClick={handleOpen}
			>
				<Icon
					id={'filter_alt'}
					color={ColorPalette.white}
					style={{ width: '30px', height: '30px' }}
				/>
			</Box>
			<Drawer
				anchor={'right'}
				open={isOpen}
				onClose={handleClose}
				sx={{
					'& > .MuiPaper-root': {
						backgroundColor: 'transparent',
						boxShadow: 'none',
					},
				}}
			>
				<Paper
					title={t('shared_texts.filters') as string}
					sx={{
						margin: '24px 40px',
						height: '100%',
						overflow: 'auto',
						position: 'relative',
					}}
				>
					<CloseModalButton
						action={handleClose}
						sx={{
							position: 'fixed',
							top: '30px',
							right: '50px',
						}}
					/>
					{children}
				</Paper>
			</Drawer>
		</>
	);
};
